export const LINK_HOMEPAGE = "/";
export const LINK_DASHBOARD = "/:clientProductId";
export const LINK_CREATE_SITE = "/:clientProductId/create-site";
export const LINK_IMPORT_SITE = "/:clientProductId/new-migration";
export const LINK_DATABASES = "/:clientProductId/databases";
export const LINK_CONTAINERS = "/:clientProductId/containers";
export const LINK_MIGRATIONS = "/:clientProductId/migrations";
export const LINK_MANAGED_KEYS = "/:clientProductId/ssh-keys";
export const LINK_FIREWALL = "/:clientProductId/firewall";
export const LINK_EMAIL = "/:clientProductId/email";
export const LINK_PMA = "/:clientProductId/pma";
export const LINK_AUDIT_LOG = "/:clientProductId/audit-log";
export const LINK_TEAM = "/:clientProductId/team";

// Site-specific links
export const LINK_SITES = "/:clientProductId/sites";
export const LINK_SITE_SETTINGS = "/:clientProductId/sites/:siteId";
export const LINK_SITE_FILE_MANAGER =
  "/:clientProductId/sites/:siteId/file-manager";
export const LINK_SITE_REDIRECTS = "/:clientProductId/sites/:siteId/redirect";
export const LINK_SITE_DATABASES = "/:clientProductId/sites/:siteId/databases";
export const LINK_SITE_SSH_KEYS = "/:clientProductId/sites/:siteId/keys";
export const LINK_SITE_CRON_JOBS = "/:clientProductId/sites/:siteId/cron";
export const LINK_SITE_CLONE = "/:clientProductId/sites/:siteId/clone";
export const LINK_SITE_SECURITY = "/:clientProductId/sites/:siteId/security";
export const LINK_SITE_TAB = "/:clientProductId/sites/:siteId/:tabValue";

// External documentation links
export const LINK_SUPPORT_DOCUMENTATION = "https://citodocs.prostack.host/";
export const LINK_SUPPORT_DOCUMENTATION_SUPPORT =
  "https://citodocs.prostack.host/support/";
export const LINK_SUPPORT_DOCUMENTATION_CACHING =
  "https://citodocs.prostack.host/managing-sites/caching";
// WHMCS portal base (no trailing slash, no /submitticket.php). Defaults to the
// production portal; dev points at its own WHMCS via NEXT_PUBLIC_PORTAL_URL
// (e.g. https://whmcs.prostack.dev), so department ids resolve against the right
// instance.
const PORTAL_BASE =
  process.env.NEXT_PUBLIC_PORTAL_URL ?? "https://www.prostack.uk/portal";
export const LINK_SUPPORT_TICKET = `${PORTAL_BASE}/submitticket.php`;
// Opens the WHMCS ticket form pre-selected to the Onboarding/migrations
// department. Prod department id is 9; dev overrides via NEXT_PUBLIC_ONBOARDING_DEPT_ID.
export const LINK_ONBOARDING_TICKET = `${PORTAL_BASE}/submitticket.php?step=2&deptid=${
  process.env.NEXT_PUBLIC_ONBOARDING_DEPT_ID ?? "9"
}`;
export const LINK_MCP_SERVER = "https://mcp.prostack.uk/";
export const LINK_SUPPORT_DOCUMENTATION_NODE =
  "https://citodocs.prostack.host/creating-sites/nodejs";
export const LINK_SUPPORT_DOCUMENTATION_SSH =
  "https://citodocs.prostack.host/getting-started/ssh-keys";
export const LINK_SUPPORT_DOCUMENTATION_REDIRECTS =
  "https://citodocs.prostack.host/managing-sites/redirects";
export const LINK_SUPPORT_DOCUMENTATION_CRON =
  "https://citodocs.prostack.host/managing-sites/crons";
export const LINK_SUPPORT_DOCUMENTATION_CHANGELOG =
  "https://citodocs.prostack.host/support/changelog/";

export const LINK_SUPPORT_DOCUMENTATION_CHANGELOG_MD =
  "https://citodocs.prostack.host/support/changelog.md";
